module.exports = __webpack_public_path__ + "img/board-lg.306eed0a.svg";